import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import api from 'utils/api';
// اضافه کردن کامپوننت تست (اختیاری)
import { toast } from 'react-toastify'; // فرض بر این است که تست دارید، اگر نه حذف کنید

const EmployeeManagement = ({ selectedSalon }) => {
  // Destructured props correctly
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [submitError, setSubmitError] = useState('');

  const [serviceOptions, setServiceOptions] = useState([]);

  // استیت فرم
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    services: [],
    workDays: [], // آرایه ای از رشته ها: ['saturday', 'monday']
    startTime: '09:00',
    endTime: '18:00',
  });

  // Load employees from backend
  useEffect(() => {
    // console.log('start getting employees');
    if (selectedSalon) {
      fetchEmployees();
      getServices();
    }
  }, [selectedSalon]);

  const getServices = async () => {
    try {
      // استفاده از selectedSalon به جای ID هاردکد شده
      const salonId = selectedSalon || '68c806bf374b8c596edb208c';
      const response = await api.get(`/salons/${salonId}/services`);
      // console.log('list of services', response.data);
      setServiceOptions(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      return [];
    }
  };

  const fetchEmployees = async () => {
    try {
      const salonId = selectedSalon || '68c806bf374b8c596edb208c';
      const { data } = await api.get(`/salons/${salonId}/employees`);
      setEmployees(data);
      setFilteredEmployees(data);
    } catch (error) {
      console.error('Error fetching employees:', error);
    }
  };

  const workDayOptions = [
    { value: 'saturday', label: 'شنبه' },
    { value: 'sunday', label: 'یکشنبه' },
    { value: 'monday', label: 'دوشنبه' },
    { value: 'tuesday', label: 'سه‌شنبه' },
    { value: 'wednesday', label: 'چهارشنبه' },
    { value: 'thursday', label: 'پنج‌شنبه' },
    { value: 'friday', label: 'جمعه' },
  ];

  // --- تغییر مهم ۱: تبدیل داده‌های فرم به ساختار workSchedule برای بک‌اند ---
  const handleFormSubmit = async (e) => {
    e?.preventDefault();
    setSubmitError('');

    // ساختن آرایه workSchedule بر اساس روزهای انتخاب شده
    // فرض می‌کنیم ساعت شروع و پایان برای همه روزها یکسان است (برای سادگی پنل)
    const workSchedule = formData.workDays.map((day) => ({
      day: day,
      startTime: formData.startTime,
      endTime: formData.endTime,
    }));

    const payload = {
      name: formData.name?.trim(),
      phone: formData.phone?.replace(/[\s-]/g, ''),
      email: formData.email?.trim().toLowerCase(),
      services: (formData.services || []).map(String),
      // ارسال workSchedule به جای workDays و workTime قدیمی
      workSchedule: workSchedule,
      // Preserve the existing value when editing instead of silently resetting it.
      status: selectedEmployee?.status || 'active',
    };

    const salonId = selectedSalon || '68c806bf374b8c596edb208c';

    try {
      if (showAddModal) {
        // ✅ CREATE new employee
        await api.post(`/salons/${salonId}/employees`, payload);
      } else if (showEditModal && selectedEmployee?._id) {
        // ✅ UPDATE existing employee
        await api.put(
          `/salons/${salonId}/employees/${selectedEmployee._id}`,
          payload
        );
      }

      // ✅ Refresh list & close modals
      await fetchEmployees();
      setShowAddModal(false);
      setShowEditModal(false);
      setSelectedEmployee(null);
      // toast.success('کارمند با موفقیت ذخیره شد!');
    } catch (error) {
      console.error('Error saving employee:', error);
      setSubmitError(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          'ذخیره کارمند انجام نشد.'
      );
      // toast.error('خطا در ذخیره اطلاعات');
    }
  };

  const handleAddEmployee = () => {
    setSubmitError('');
    setFormData({
      name: '',
      phone: '',
      email: '',
      services: [],
      workDays: [],
      startTime: '09:00',
      endTime: '18:00',
    });
    setShowAddModal(true);
  };

  const normalizedServiceOptions = serviceOptions.map((s) => ({
    value: s._id,
    label: s.name,
  }));

  // --- تغییر مهم ۲: پر کردن فرم هنگام ویرایش بر اساس workSchedule ---
  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee);
    setSubmitError('');

    // استخراج روزها از workSchedule
    const existingWorkDays = employee.workSchedule
      ? employee.workSchedule.map((w) => w.day)
      : employee.workDays || []; // Fallback برای دیتای قدیمی

    // استخراج ساعت از اولین روز کاری (چون در پنل فعلی یک ساعت کلی داریم)
    const existingStartTime = employee.workSchedule?.[0]?.startTime || '09:00';
    const existingEndTime = employee.workSchedule?.[0]?.endTime || '18:00';

    setFormData({
      name: employee?.name || '',
      phone: employee?.phone || '',
      email: employee?.email || '',
      services: (employee?.services || []).map((service) =>
        typeof service === 'object' ? String(service?._id || service?.id) : String(service)
      ),
      workDays: existingWorkDays,
      startTime: existingStartTime,
      endTime: existingEndTime,
    });

    setShowEditModal(true);
  };

  const handleDeleteEmployee = (employee) => {
    setSelectedEmployee(employee);
    setShowDeleteModal(true);
  };

  // تابع حذف واقعی
  const confirmDelete = async () => {
    if (!selectedEmployee) return;
    try {
      const salonId = selectedSalon || '68c806bf374b8c596edb208c';
      await api.delete(`/salons/${salonId}/employees/${selectedEmployee._id}`);
      fetchEmployees();
      setShowDeleteModal(false);
      setSelectedEmployee(null);
    } catch (error) {
      console.error('Delete failed', error);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'text-success bg-success/10';
      case 'inactive':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header and Search */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            مدیریت کارکنان
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            مدیریت اطلاعات و برنامه کاری کارکنان سالن
          </p>
        </div>
        <Button
          variant="default"
          onClick={handleAddEmployee}
          iconName="Plus"
          iconPosition="right">
          افزودن کارمند جدید
        </Button>
      </div>

      {/* Mobile Employee Cards */}
      <div className="lg:hidden space-y-3">
        {filteredEmployees.map((employee) => (
          <div key={employee._id} className="bg-card border border-border rounded-lg p-4 space-y-3">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-semibold text-foreground">{employee.name}</p>
                <p className="text-sm text-muted-foreground">{employee.phone}</p>
              </div>
              <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(employee.status)}`}>
                {employee.status === 'active' ? 'فعال' : 'غیرفعال'}
              </span>
            </div>

            <div className="space-y-2 text-sm">
              <div>
                <span className="text-muted-foreground">ایمیل:</span>
                <p className="text-foreground">{employee.email || '-'}</p>
              </div>
              <div>
                <span className="text-muted-foreground">خدمات:</span>
                <p className="text-foreground">
                  {employee.services?.map((s) => (typeof s === 'object' ? s.name : s)).join('، ') || '-'}
                </p>
              </div>
            </div>

            <div className="flex gap-2 pt-2 border-t border-border">
              <Button
                size="sm"
                variant="ghost"
                onClick={() => handleEditEmployee(employee)}
                iconName="Edit"
                iconSize={16}
                className="flex-1">
                ویرایش
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => handleDeleteEmployee(employee)}
                iconName="Trash2"
                iconSize={16}
                className="flex-1 text-error">
                حذف
              </Button>
            </div>
          </div>
        ))}
      </div>

      {/* Employee Table - Desktop */}
      <div className="hidden lg:block bg-card border border-border rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  کارمند
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  اطلاعات تماس
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  خدمات
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  روزهای کاری
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  ساعات کاری
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  وضعیت
                </th>
                <th className="text-center px-6 py-4 text-sm font-medium text-foreground">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filteredEmployees?.map((employee) => {
                // محاسبه روزها و ساعات برای نمایش در جدول
                const displayDays =
                  employee.workSchedule?.map((w) => w.day).join('، ') || '-';
                const displayTime = employee.workSchedule?.[0]
                  ? `${employee.workSchedule[0].startTime} - ${employee.workSchedule[0].endTime}`
                  : '-';

                return (
                  <tr
                    key={employee?._id}
                    className="hover:bg-muted/30 transition-colors duration-150">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full overflow-hidden bg-muted">
                          <img
                            src={
                              employee?.avatar ||
                              'https://i.ibb.co/JW1sG7MT/avatar.png'
                            }
                            alt={employee?.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground">
                            {employee?.name}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="space-y-1">
                        <p className="text-sm text-foreground">
                          {employee?.phone}
                        </p>
                        <p className="text-xs text-muted-foreground">
                          {employee?.email}
                        </p>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex flex-wrap gap-1">
                        {employee?.services
                          ?.slice(0, 2)
                          .map((service, index) => (
                            <span
                              key={index}
                              className="inline-block px-2 py-1 text-xs bg-primary/10 text-primary rounded-md">
                              {typeof service === 'object'
                                ? service?.name
                                : 'سرویس'}
                            </span>
                          ))}
                        {employee?.services?.length > 2 && (
                          <span className="inline-block px-2 py-1 text-xs bg-muted text-muted-foreground rounded-md">
                            +{employee?.services?.length - 2}
                          </span>
                        )}
                      </div>
                    </td>

                    <td className="px-6 py-4">
                      <p
                        className="text-sm text-foreground truncate max-w-[150px]"
                        title={displayDays}>
                        {displayDays}
                      </p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-foreground ltr text-right">
                        {displayTime}
                      </p>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-block px-2 py-1 text-xs rounded-md ${getStatusColor(
                          employee?.status || 'active'
                        )}`}>
                        {employee?.status === 'active' ? 'فعال' : 'غیرفعال'}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center justify-center gap-2">
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => handleEditEmployee(employee)}
                          iconName="Edit"
                          iconSize={16}
                        />
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => handleDeleteEmployee(employee)}
                          iconName="Trash2"
                          iconSize={16}
                          className="text-error hover:text-error"
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add/Edit Employee Modal */}
      {(showAddModal || showEditModal) && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto animate-scale-in">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-foreground">
                  {showAddModal
                    ? 'افزودن کارمند جدید'
                    : 'ویرایش اطلاعات کارمند'}
                </h3>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    setShowAddModal(false);
                    setShowEditModal(false);
                  }}
                  iconName="X"
                  iconSize={20}
                />
              </div>

              <form onSubmit={handleFormSubmit} className="space-y-4">
                {submitError ? (
                  <div className="rounded-md border border-error/30 bg-error/10 px-3 py-2 text-sm text-error">
                    {submitError}
                  </div>
                ) : null}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="نام و نام خانوادگی"
                    type="text"
                    placeholder="نام کارمند را وارد کنید"
                    value={formData?.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e?.target?.value })
                    }
                    required
                  />
                  <Input
                    label="شماره تلفن"
                    type="tel"
                    placeholder="09123456789"
                    value={formData?.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e?.target?.value })
                    }
                    required
                  />
                </div>

                <Input
                  label="آدرس ایمیل"
                  type="email"
                  placeholder="example@salon.com"
                  value={formData?.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e?.target?.value })
                  }
                />
                <Select
                  label="خدمات ارائه شده"
                  description="خدماتی که این کارمند ارائه می‌دهد"
                  options={normalizedServiceOptions}
                  value={formData?.services}
                  onChange={(value) =>
                    setFormData({ ...formData, services: value })
                  }
                  multiple
                  searchable
                  required
                />

                <Select
                  label="روزهای کاری"
                  description="روزهایی که این کارمند در دسترس است"
                  options={workDayOptions}
                  value={formData?.workDays}
                  onChange={(value) =>
                    setFormData({ ...formData, workDays: value })
                  }
                  multiple
                  required
                />

                <div className="grid grid-cols-2 gap-4">
                  <Input
                    label="ساعت شروع کار"
                    type="time"
                    value={formData?.startTime}
                    onChange={(e) =>
                      setFormData({ ...formData, startTime: e?.target?.value })
                    }
                    required
                  />
                  <Input
                    label="ساعت پایان کار"
                    type="time"
                    value={formData?.endTime}
                    onChange={(e) =>
                      setFormData({ ...formData, endTime: e?.target?.value })
                    }
                    required
                  />
                </div>

                <div className="flex gap-3 pt-4">
                  <Button type="submit" variant="default" className="flex-1">
                    {showAddModal ? 'افزودن کارمند' : 'ذخیره تغییرات'}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setShowAddModal(false);
                      setShowEditModal(false);
                    }}
                    className="flex-1">
                    انصراف
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedEmployee && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-md animate-scale-in">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center">
                  <Icon name="AlertTriangle" size={20} className="text-error" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground">
                    حذف کارمند
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    این عمل قابل بازگشت نیست
                  </p>
                </div>
              </div>

              <p className="text-sm text-foreground mb-6">
                آیا از حذف کارمند <strong>{selectedEmployee?.name}</strong>{' '}
                اطمینان دارید؟ تمام اطلاعات مربوط به این کارمند حذف خواهد شد.
              </p>

              <div className="flex gap-3">
                <Button
                  variant="destructive"
                  onClick={confirmDelete}
                  className="flex-1">
                  حذف کارمند
                </Button>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setSelectedEmployee(null);
                  }}
                  className="flex-1">
                  انصراف
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeManagement;
